<template>
  <div class="is-clearfix" v-if="job.applicationStatus">
    <user-image size="is-24x24" class="is-pulled-right" v-tooltip="applicantTooltip" />
    <div v-if="job.referrerId" class="is-pulled-right image is-circular is-24x24 m-r-8" >
      <img v-tooltip="referralTootip" v-if="imageUrl" :src="imageUrl">
    </div>
  </div>
  <div v-else class="image-size"></div>
</template>
<script>
import UserImage from '@/components/general/user-image'
import UserHelper from '@/helpers/user'
import moment from 'moment'
import _ from 'lodash'

export default {
  components: { UserImage },
  props: {
    job: {
      type: Object,
      required: true
    }
  },
  computed: {
    imageUrl () {
      return UserHelper.getProfilePicture(this.job.referrerAvatar, this.job.referrerId)
    },
    referralTootip () {
      return `Referred by: ${this.job.referrerName}`
    },
    applicantTooltip () {
      let tooltiptext = ''
      switch (this.job.applicationStatus) {
        case 'pending':
          tooltiptext = 'Applied'
          break
        default:
          tooltiptext = _.upperFirst(this.job.applicationStatus)
      }
      tooltiptext += `: ${moment(this.job.applicationUpdatedAt).format('DD MMM YY')}`
      return tooltiptext
    }
  }
}
</script>

<style scoped>
.image-size{
  height: 24px
}
</style>



// WEBPACK FOOTER //
// src/components/jobs/applicant_and_referrer.vue